var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 5.34375V8.71875L8.8125 7.03125L5.8125 5.34375ZM14 1.5C14 0.6875 13.3125 0 12.5 0H1.5C0.65625 0 0 0.6875 0 1.5V12.5C0 13.3438 0.65625 14 1.5 14H12.5C13.3125 14 14 13.3438 14 12.5V1.5ZM12.6875 7.03125C12.6875 7.03125 12.6875 8.875 12.4375 9.78125C12.3125 10.2812 11.9062 10.6562 11.4375 10.7812C10.5312 11 7 11 7 11C7 11 3.4375 11 2.53125 10.7812C2.0625 10.6562 1.65625 10.2812 1.53125 9.78125C1.3125 8.875 1.3125 7.03125 1.3125 7.03125C1.3125 7.03125 1.3125 5.15625 1.53125 4.28125C1.65625 3.78125 2.0625 3.375 2.53125 3.25C3.4375 3 7 3 7 3C7 3 10.5312 3 11.4375 3.25C11.9062 3.375 12.3125 3.78125 12.4375 4.28125C12.6875 5.15625 12.6875 7.03125 12.6875 7.03125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8954f80efa992db7e7e66575c5f95c1e.svg";
export { ForwardRef as ReactComponent };